import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import FieldSelect from '../common/FieldSelect';
import PropertyAPI from '../../api/PropertyAPI';
import FieldText from '../common/FieldText';
import FieldDecimal from '../common/FieldDecimal';

import Util from '../../util/Util';
import Display from '../../util/Display';
import Const from '../../util/Constants';
import PropertyController from '../../controller/PropertyController';
import Calculate from '../../util/Calculate';
class PropertyPopup extends React.Component {

  constructor(props) {
    super(props);

    this.model = reactLocalStorage.getObject(Const.Model).property;
    this.property = PropertyController.addModel(this.model.fields);
    this.property.project = props.model_id;
    this.property.is_project_property = 1;
    this.property.id = 0;
    this.property.available_date = props.project.posession_date ? 
      props.project.posession_date : this.property.available_date;
    this.property.area = props.project.area || '';
     this.state = { inValid: {}, property: { ...this.property }, inApiCall: false };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props && props.property && props.property.id !== this.state.property.id) {
      this.setState({ ...this.state, property: { ...props.property }});
    } else if(props.property === null) { 
      this.setState({ ...this.state, property: { ...this.property }}); 
    }
  }

  onChange = (field, value) => {
    let property = { ...this.state.property };
    
    if(field === 'property_type') {
      let propertytypename = {};
      propertytypename[field] = value;
      const propertytype = Display.FieldValue(propertytypename, field, this.model.fields);
      let projectname = this.props.project.project_name;
      property['name'] = projectname.replace(/\s+/g, '-').toLowerCase() + '-' + propertytype;
    }
    
    property[field] = value;
    property = this.onChangeCalculate(-1, property, field);
    this.setState({ ...this.state, property: { ...property }, inValid: {} });
  }

  onChangeCalculate = (index, sale, skipField) => {
    const keys = Object.keys(this.model.fields);
    let inner = [];
    
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (skipField !== key
        && key.includes(Const.T_Product) && key.includes(Const.Opt)
        && this.model.fields[key].calculate && this.model.fields[key].calculate !== '') {
        inner.push(key);
      }
    }

    inner = inner.sort((left, right) => {
      if (this.model.fields[left].field_order > this.model.fields[right].field_order) return 1;
      else if (this.model.fields[left].field_order < this.model.fields[right].field_order) return -1;
      else return 0;
    });

    if (index > -1) {
      for (let i = 0; i < inner.length; i++) {
        const field = inner[i];
        const type = this.model.fields[field].field_type;
        const fieldKeys = this.model.fields[field].field_key.split('~');

        if (type === Const.Discount || type === Const.Commission || type === Const.Tax) {
          const tmp = JSON.parse(this.model.fields[field].calculate);
          if (!sale.products[index][fieldKeys[1]]) {
            sale.products[index][fieldKeys[1]] = {};
          }
          if (tmp) {
            if (tmp.pre && tmp.pre.includes(skipField)) {
              sale.products[index][fieldKeys[1]][Const.TypePre] = Calculate.calculate(this.model.fields,
                index, sale, tmp.pre);
            }
            if (tmp.amount && tmp.amount.includes(skipField)) {
              sale.products[index][fieldKeys[1]][Const.TypeAmt] = Calculate.calculate(this.model.fields,
                index, sale, tmp.amount);
            }
          } else {
            sale.products[index][fieldKeys[1]][Const.TypePre] = 0;
            sale.products[index][fieldKeys[1]][Const.TypeAmt] = 0;
          }
        } else {
          const calculate = this.model.fields[field].calculate;
          if (calculate && calculate.includes(skipField)) {
            sale.products[index][fieldKeys[1]] = Calculate.calculate(this.model.fields, index, sale, calculate);
          }
        }
      }
    }
    
    inner = [];
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (skipField !== key
        && !key.includes(Const.T_Product) && !key.includes(Const.Opt)
        && this.model.fields[key].calculate && this.model.fields[key].calculate !== '') {
        inner.push(key);
      }
    }
    
    inner = inner.sort((left, right) => {
      if (this.model.fields[left].field_order > this.model.fields[right].field_order) return 1;
      else if (this.model.fields[left].field_order < this.model.fields[right].field_order) return -1;
      else return 0;
    });

    for (let i = 0; i < inner.length; i++) {
      const field = inner[i];
      const calculate = this.model.fields[field].calculate;
      if (calculate && calculate.includes(skipField)) {
        sale[field] = Calculate.calculate(this.model.fields, index, sale, calculate);
      }
    }
    
    return sale;
  }

  onSave = () => {
    PropertyAPI.saveProperty(this.state.property, this.onSaved, this.onFailure, this.props.logout);
    this.setState({ ...this.state, inApiCall: true });
  }

  onSaved = res => {
    Util.showNotification('Successful', 'Property saved successfully', 'success');
    this.setState({ ...this.state, property: { ...this.state.property, id: res.id}, inApiCall: false });
    this.props.onHide();
    if(this.props.reload) this.props.reload();
  }

  onFailure = err => {
    Util.showError(err);
  }

  render() {
    
    const fields = this.model.fields;
    const inValid = this.state.inValid;
    const property = this.state.property;
    
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered onExit={() => this.isAPICalled = false }>
        
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Configuration</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <FieldSelect key="property_type" id="property_type"
              field={fields.property_type} value={property.property_type}
              onValueChange={this.onChange} inValid={inValid} />

            <FieldSelect key="type" id="type"
              field={fields.type} value={property.type}
              onValueChange={this.onChange} inValid={inValid} />

            <FieldText key="build_area" id="build_area" field={fields.build_area}
              value={property.build_area} onValueChange={this.onChange} inValid={inValid} />

            <FieldText key="carpet_area" id="carpet_area" field={fields.carpet_area}
              value={property.carpet_area} onValueChange={this.onChange} inValid={inValid} />
            
            <FieldDecimal key="price" id="price" field={fields.price}
              value={property.price} onValueChange={this.onChange} inValid={inValid} />

            <FieldSelect key="property_transaction" id="property_transaction"
              field={fields.property_transaction} value={property.property_transaction}
              onValueChange={this.onChange} inValid={inValid} />

            <FieldDecimal key="developement_charge" id="developement_charge" field={fields.developement_charge}
              value={property.developement_charge} onValueChange={this.onChange} inValid={inValid} />

            <FieldDecimal key="parking_charges" id="parking_charges" field={fields.parking_charges}
              value={property.parking_charges} onValueChange={this.onChange} inValid={inValid} />

            <FieldDecimal key="society_charges" id="society_charges" field={fields.society_charges}
              value={property.society_charges} onValueChange={this.onChange} inValid={inValid} />

            <FieldDecimal key="other_charges" id="other_charges" field={fields.other_charges}
              value={property.other_charges} onValueChange={this.onChange} inValid={inValid} />

            <FieldDecimal key="stamp_duty" id="stamp_duty" field={fields.stamp_duty}
              value={property.stamp_duty} onValueChange={this.onChange} inValid={inValid} />

            <FieldDecimal key="registration" id="registration" field={fields.registration}
              value={property.registration} onValueChange={this.onChange} inValid={inValid} />
            
            <FieldDecimal key="agreement_price" id="agreement_price" field={fields.agreement_price}
              value={property.agreement_price} onValueChange={this.onChange} inValid={inValid} />
              
            <FieldText key="wing" id="wing" field={fields.wing}
              value={property.wing} onValueChange={this.onChange} inValid={inValid} />

          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={this.onSave} disabled={this.state.inApiCall}>
            {this.state.inApiCall ? 'Saving...' : 'Submit'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default PropertyPopup;